<template>
  <div class="inter-wrapper">
    <HeaderInter :back-path="() => { $emit('cancel') }" :showbackbtn="true" />
    <div class="inter-content container-fluid">
      <div class="area-row row">
        <span class="area-label col-3">{{ $langt('地點') }}</span>
        <select class="area-select  form-control col-9" v-model="mainValue" @change="onMainValueChange">
          <option v-for="o in mainOptions" :value="o.value">{{ o.label }}</option>
        </select>
      </div>
      <div class="area-row row" v-if="subOptions !== null && subOptions.length > 0">
        <span class="area-label col-3">{{ $langt('區域') }}</span>
        <select class="area-select form-control col-9" v-model="subValue">
          <option v-for="o in subOptions" :value="o.value">{{ o.label }}</option>
        </select>
      </div>
      <div class="area-row row justify-content-center">
        <button class="btn btn-next line col-6" type="button" @click="$emit('change', (subValue === null) ? mainValue : subValue)">
          {{ $langt('確認') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInter from '@/components/HeaderInter'

export default {
  emits: ['change', 'cancel'],
  props: {
    item: { type: Array, default() { return [] } },
    value: { type: [String, Number], default() { return null } },
  },
  data() {
    return {
      mainValue: null,  // 主選單的選項 //
      subValue: null,   // 次選單的選項 //
    }
  },
  components: {
    HeaderInter
  },
  computed: {
    mainOptions() {
      return this.item.map(e => ({label: e.name, value: e.area_id}))
    },
    subOptions() {
      const mainItem = this.item.find(e => e.area_id === this.mainValue)
      return (mainItem === undefined) ? null : mainItem.regions.map(e => ({label: e.name, value: e.area_id}))
    }
  },
  methods: {
    // 主選單異動，更換副選單 //
    onMainValueChange() {
      this.subValue = (Array.isArray(this.subOptions) && this.subOptions.length) ?
        this.subOptions[0].value : null
    },
    // 設定選單的選項 (prop.value) //
    setValue(value) {
      this.item.forEach(e => {
        if (e.area_id === value) {
          this.mainValue = e.area_id
          this.subValue = null
        } else {
          if (Array.isArray(e.regions)) {
            e.regions.forEach(r => {
              if (r.area_id === value) {
                this.mainValue = e.area_id
                this.subValue = r.area_id
              }
            })
          }
        }
      })
    }
  },
  mounted() {
    this.setValue(this.value)
  }
}
</script>

<style lang="css" scoped>
.area-row {
  width: 80%;
  margin: 2rem auto;
}

.area-label {
  color: #545454;
  font-size: 1rem;
}

.area-select {
  color: white;
  border-radius: 3rem;
  /* modify select drop down symbol */
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url(~@/assets/images/arrow-down.svg) no-repeat calc(100% - 15px) center;
  background-size: 10px;
}
</style>
